import { Application } from '../constants/application';
import { MessageType } from '../constants/message-type';

export class Message {
  public static LIB_VERSION = '1.2.1';
  version: string = Message.LIB_VERSION;
  public id: string;
  public portalId?: string;
  public type: MessageType;
  public source: Application;
  public destination: Application;
  public message: any;

  constructor(id: string, type: MessageType, source: Application, destination: Application, message: any, portalId?: string) {
    this.id = id;
    this.type = type;
    this.source = source;
    this.destination = destination;
    this.message = message;
    this.portalId = portalId;
  }
}